import React, { FC } from 'react';

import {
	EvFiltersPanelBar,
	IEvFiltersPanelDefinition,
	TEvFiltersPanelValues
} from '@evinced-private/ui-common';

import { PINNED_DATE_RANGE_MAX_VISIBLE_CHIPS } from 'src/common/consts/FilterPanelConsts';

import { useFiltersPanelOverflowModal } from './useFiltersPanelOverflowModal';

import './ProductFiltersPanel.scss';

interface TPinnedDateRangeFiltersPanelBarProps {
	maxVisibleChips?: number;
	triggerLabel?: string;
	panelDefinitions: IEvFiltersPanelDefinition[];
	appliedValues: TEvFiltersPanelValues;
	onApply: (values: TEvFiltersPanelValues) => void;
}

export const PinnedDateRangeFiltersPanelBar: FC<TPinnedDateRangeFiltersPanelBarProps> = ({
	maxVisibleChips = PINNED_DATE_RANGE_MAX_VISIBLE_CHIPS,
	triggerLabel,
	panelDefinitions,
	appliedValues,
	onApply
}) => {
	const { showMoreChipsProps, overflowModal } = useFiltersPanelOverflowModal({
		panelDefinitions,
		appliedValues,
		onApply
	});

	return (
		<div className="product-filters-panel__bar">
			<EvFiltersPanelBar
				showTrigger={false}
				maxVisibleChips={maxVisibleChips}
				triggerLabel={triggerLabel}
				showMoreChipsProps={showMoreChipsProps}
			/>
			{overflowModal}
		</div>
	);
};
